var map = {
	"./Template-FedEx.svg": 3726,
	"./Template-UPS.svg": 3727,
	"./Template-USPS.svg": 3728
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3725;


//////////////////
// WEBPACK FOOTER
// ./src/themes/default/modules/channel/pages ^\.\/Template\-.*\.svg$
// module id = 3725
// module chunks = 4